// API Base URL Configuration
export const API_BASE_URL =
  process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000';

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    RESET_PASSWORD_REQUEST: '/auth/password/request',
    VERIFY_CODE: '/auth/password/verify',
    RESET_PASSWORD: '/auth/password/reset',
    CHANGE_PASSWORD: '/auth/password/change',
  },
  USERS: {
    BASE: '/users',
    BY_ID: (id) => `/users/${id}`,
    IMPORT_OPTIONS: '/users/import/options',
    IMPORT_TEMPLATE: '/users/import/template',
    IMPORT_INSPECT: '/users/import/inspect',
    IMPORT: '/users/import',
    IMPORT_REPORT: '/users/import/report',
    TEMPORARY_PASSWORD: (id) => `/users/${id}/temporary-password`,
  },
  ROLES: {
    BASE: '/roles',
  },
  SURVEY: {
    BASE: '/survey-submission',
    BY_ID: (id) => `/survey-submission/${id}`,
    EXPORT: '/survey-submission/export',
    FILTER_OPTIONS: '/survey-submission/filter-options',
  },
  QUESTIONS: {
    BASE: '/questions',
    BY_ID: (id) => `/questions/${id}`,
    TYPES: '/questions/types',
  },
  DASHBOARD: {
    STATS: '/dashboard/stats',
    SURVEY_EVOLUTION: '/dashboard/survey-evolution',
    COMPANIES_BY_SECTOR: '/dashboard/companies-by-sector',
    VISUALIZATION_EXERCICES: '/dashboard/visualizations/exercices',
    VISUALIZATION_CATALOG: '/dashboard/visualizations/catalog',
    VISUALIZATION_PREVIEW: '/dashboard/visualizations/preview',
    VISUALIZATIONS: '/dashboard/visualizations',
    VISUALIZATION_BY_ID: (id) => `/dashboard/visualizations/${id}`,
  },
  SURVEY_FIELDS: {
    BASE: '/survey-fields',
    BY_KEY: (key) => `/survey-fields/${encodeURIComponent(key)}`,
  },
  PRO_DASHBOARD: {
    SUMMARY: '/pro-dashboard/summary',
    MONTHLY_SURVEYS: '/pro-dashboard/monthly-surveys',
    COMPANY_SECTORS: '/pro-dashboard/company-sectors',
  },
  COMPANY_MEDIA: {
    BASE: '/storage/company-media',
    SIGNED_URL: '/storage/company-media/signed-url',
  },
  SAVED_FILTERS: {
    BASE: '/saved-filters',
    BY_ID: (id) => `/saved-filters/${id}`,
  },
  COMPANY: {
    BASE: '/company',
    BY_ID: (id) => `/company/${id}`,
    EXPORT: '/company/export',
    EXPORT_ONE: (id) => `/company/${id}/export`,
    EXPORT_ONE_PDF: (id) => `/company/${id}/export/pdf`,
    FILTER_OPTIONS: '/company/filter-options',
    MATCHES: '/company/matches',
    SURVEY_PREFILL: (id) => `/company/${id}/survey-prefill`,
    SURVEYS_COMPARE: (id) => `/company/${id}/surveys/compare`,
  },
};

// Storage Keys
export const STORAGE_KEYS = {
  JWT: 'jwt',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  ROLE: 'user_role',
  REDIRECT_AFTER_LOGIN: 'redirect_after_login',
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  STORAGE_KEYS,
};
